import * as React from 'react';
import gql from 'graphql-tag';
import { ChildProps, graphql, compose } from 'react-apollo';

const CategoriesQuery = gql`
  query categories($domain: String, $search: String) {
    categories(where: { eshop: { domain: $domain }, title_contains: $search }) {
      id
      parentCategory {
        id
        title
        eshop {
          id
          name
        }
      }
      eshop {
        id
        name
      }
      title
      name
      longName
      description
      metaTitle
      metaDescription
      priority
      slug
      image
      banner
      bannerLink
      active
      attributes {
        id
        title
        isVisual
        name
        definition
        type
        values {
          id
          title
          value
          colorHex
        }
      }
      longDescription
    }
    languages {
      id
      value
    }
  }
`;

const CreateCategoryMutation = gql`
  mutation createCategory($category: CreateCategoryInput!) {
    createCategory(category: $category) {
      id
    }
  }
`;

const UpdateCategoryMutation = gql`
  mutation updateCategory($id: String!, $category: UpdateCategoryInput!) {
    updateCategory(id: $id, category: $category) {
      id
    }
  }
`;

const DeleteCategoryMutation = gql`
  mutation deleteCategory($id: String!) {
    deleteCategory(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
  domain: string;
  search?: string;
  cache?: boolean;
}

interface Response {
  data: any;
}

class GetCategoriesQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { categories, createCategory, updateCategory, deleteCategory }: any = this.props;
    return this.props.children({
      categories,
      updateCategory,
      createCategory,
      deleteCategory
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(CategoriesQuery, {
    name: 'categories',
    options: props => ({
      variables: { domain: props.domain, search: props.search || '' },
      fetchPolicy: props.cache == undefined || props.cache === true ? 'cache-first' : 'network-only'
    })
  }),
  graphql<IInputProps, Response>(UpdateCategoryMutation, {
    name: 'updateCategory'
  }),
  graphql<IInputProps, Response>(CreateCategoryMutation, {
    name: 'createCategory'
  }),
  graphql<IInputProps, Response>(DeleteCategoryMutation, {
    name: 'deleteCategory'
  })
)(GetCategoriesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Categories/Categories.tsx